import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_7'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_7',
  name: 'Does the facility have any of the following safety measures in place regarding eyewash stations and showers?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'EYEWASH_STATIONS_AND_SHOWERS_ARE_CLEARLY_IDENTIFIABLE',
      text: 'Eyewash stations and showers are clearly identifiable',
      externalIds: [
        {
          id: 'hs-27--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EYEWASH_STATIONS_AND_SHOWERS_ARE_EASY_TO_ACCESS',
      text: 'Eyewash stations and showers are easy to access',
      externalIds: [
        {
          id: 'hs-27--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EYEWASH_STATIONS_AND_SHOWERS_ARE_CLEAR_OF_CLUTTER_DEBRIS',
      text: 'Eyewash stations and showers are clear of clutter/debris',
      externalIds: [
        {
          id: 'hs-27--2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EYEWASH_STATIONS_AND_SHOWERS_USE_POTABLE_WATER_AT_THE_RIGHT_TEM',
      text: 'Eyewash stations and showers use potable water at the right temp and pressure',
      externalIds: [
        {
          id: 'hs-27--2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EYEWASH_STATIONS_AND_SHOWERS_ARE_REGULARLY_INSPECTED',
      text: 'Eyewash stations and showers are regularly inspected',
      externalIds: [
        {
          id: 'hs-27--2-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-27--2-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'EYEWASH_STATIONS_AND_SHOWERS_ARE_CLEARLY_IDENTIFIABLE',
                'EYEWASH_STATIONS_AND_SHOWERS_ARE_EASY_TO_ACCESS',
                'EYEWASH_STATIONS_AND_SHOWERS_ARE_CLEAR_OF_CLUTTER_DEBRIS',
                'EYEWASH_STATIONS_AND_SHOWERS_USE_POTABLE_WATER_AT_THE_RIGHT_TEM',
                'EYEWASH_STATIONS_AND_SHOWERS_ARE_REGULARLY_INSPECTED',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-che-5',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15440,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
